import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import { Calendar, DateObject } from 'react-multi-date-picker';
import moment from 'moment';
import { useForm } from 'react-hook-form';
import Dropdown from '../../base/Dropdown/Dropdown';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import gregorian_ru from './gregorian_ru';
import TextInput from '../TextInput/TextInput';
import './RangeDatePickerStyles.scss';
import FieldDTOWithCol from '../Abstract/FieldDTOWithCol';
import DateTimePicker from '../DatePicker/DateTimePicker';
import FieldDTO from '../Abstract/FieldDTO';

export default function DateTimeRangePicker(props) {
  const {
    className = '',
    inline = false,
    inputProps = {},
    usePortal = false,
    changeFormat = null,
    onChangeToIso = false,
    disabled = false,
    prefix = '',
    dtoObject = '',
    label = '',
  } = props;
  const { value, onChange } = inputProps;
  const { control, watch, setValue } = useForm({
    defaultValues: {
      start: value?.length ? value[0] : null,
      end: value?.length === 2 ? value[1] : null,
    },
  });
  useEffect(() => {
    setValue('start', value?.length ? value[0] : null);
    setValue('end', value?.length === 2 ? value[1] : null);
  }, [JSON.stringify(value)]);
  useEffect(() => {
    const subscription = watch(values => {
      const s = values.start || null;
      const e = values.end || null;
      onChange([s, e]);
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  return (
    <div className={classNames('range-date-time-picker', { 'inline-picker': inline }, className)}>
      <FieldDTO
        control={control}
        type="text"
        component={DateTimePicker}
        changeFormat={changeFormat || 'YYYY-MM-DDTHH:mm:ss'}
        onChangeToIso={onChangeToIso}
        usePortal={usePortal}
        withLabel
        dtoObject={{
          name: 'start',
          type: String,
          labelKey: 'trip_ended_at',
        }}
        label={`${label} от`}
        variant="material"
        namePrefix={prefix}
        disabled={disabled}
      />
      <FieldDTO
        control={control}
        type="text"
        component={DateTimePicker}
        changeFormat={changeFormat || 'YYYY-MM-DDTHH:mm:ss'}
        onChangeToIso={onChangeToIso}
        usePortal={usePortal}
        withLabel
        dtoObject={{
          name: 'end',
          type: String,
          labelKey: 'trip_ended_at',
        }}
        label={`${label} до`}
        variant="material"
        namePrefix={prefix}
        disabled={disabled}
      />
    </div>
  );
}
